export default [
  {
    path: '/product/apply',
    name: 'ProductApplyList',
    component: () => import('@/views/product/ApplyList.vue')
  },
  {
    path: '/product',
    name: 'ProductList',
    component: () => import('@/views/product/ProductList.vue')
  },
  {
    path: '/product/:productNo',
    name: 'ProductView',
    component: () => import('@/views/product/ProductView.vue')
  }
];
